/* NĒM cart page. The markup carries the same hooks as the drawer, but the
   drawer's handler only re-renders the drawer, which would leave the page
   totals stale. These capture-phase listeners claim the events first, mutate
   the cart, then reload so every price on the page is right. Without
   JavaScript the surrounding form and the remove links still work on their own. */
(function () {
  'use strict';

  var page = document.querySelector('[data-cart-page], .oxy-cart-page');
  if (!page) return;

  var routes = (window.oxyvape || {}).routes || {};
  var busy = false;

  function changeLine(key, quantity) {
    if (busy) return;
    busy = true;
    page.setAttribute('aria-busy', 'true');

    fetch(routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart error');
        window.location.reload();
      })
      .catch(function () {
        busy = false;
        page.removeAttribute('aria-busy');
        window.location.reload();
      });
  }

  document.addEventListener(
    'click',
    function (event) {
      var remove = event.target.closest('[data-cart-remove]');
      if (remove && page.contains(remove)) {
        event.preventDefault();
        event.stopPropagation();
        changeLine(remove.dataset.key, 0);
        return;
      }

      var down = event.target.closest('[data-qty-down]');
      var up = event.target.closest('[data-qty-up]');
      if (!down && !up) return;

      var stepper = (down || up).closest('[data-qty]');
      if (!stepper || !page.contains(stepper)) return;

      event.preventDefault();
      event.stopPropagation();

      var input = stepper.querySelector('[data-qty-input]');
      var next = (parseInt(input.value, 10) || 0) + (up ? 1 : -1);
      if (next < 0) next = 0;
      input.value = next;
      changeLine(input.dataset.key, next);
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      var input = event.target.closest('[data-qty-input]');
      if (!input || !page.contains(input)) return;

      event.stopPropagation();

      var quantity = parseInt(input.value, 10);
      if (isNaN(quantity) || quantity < 0) quantity = 0;
      changeLine(input.dataset.key, quantity);
    },
    true
  );
})();
